export enum PageValidationErrorNamesEnum {
  OK = 'OK',
  MSISDN_MISSING = 'MSISDN_MISSING',
  NO_OFFER_IN_CART = 'NO_OFFER_IN_CART',
  REQUIRED_LOGIN = 'REQUIRED_LOGIN',
  NO_MSISDN_FOR_TV_ADDON = 'NO_MSISDN_FOR_TV_ADDON',
  NO_RETENTION_STATUS_CHECK = 'NO_RETENTION_STATUS_CHECK',
  STOCK_NOT_CHECKED = 'STOCK_NOT_CHECKED',
  INVALID_OPERATOR = 'INVALID_OPERATOR',
  NO_MSISDN_FOR_TV_OFFER = 'NO_MSISDN_FOR_TV_OFFER',
  UNSUPPORTED_CUSTOMER_TYPE = 'UNSUPPORTED_CUSTOMER_TYPE',
  CART_VALUE_EXCEEDED = 'CART_VALUE_EXCEEDED',
  INVALID_MNP_NUMBER = 'INVALID_MNP_NUMBER',

  /*
   * Show Lead for:
   */
  INVALID_BRAND = 'INVALID_BRAND',
  INVALID_SERVICE_TYPE = 'INVALID_SERVICE_TYPE',
  INDIVIDUAL_ON_BUSINESS_ONLY_OFFER = 'INDIVIDUAL_ON_BUSINESS_ONLY_OFFER',
  BUSINESS_CLIENT_ON_INDIVIDUAL_ONLY_OFFER = 'BUSINESS_CLIENT_ON_INDIVIDUAL_ONLY_OFFER',
  BUSINESS_SME_CUSTOMER = 'BUSINESS_SME_CUSTOMER',
  CUSTOMER_STATUS_S1 = 'CUSTOMER_STATUS_S1',
  RETENTION_LOCKED = 'RETENTION_LOCKED',
  RETENTION_NOT_ELIGIBLE_OFFER = 'RETENTION_NOT_ELIGIBLE_OFFER',
  INVALID_TRAFFIC_TYPE = 'INVALID_TRAFFIC_TYPE',
  HAS_PENDING_ORDER = 'HAS_PENDING_ORDER',
  NO_TARIFF_MIGRATION = 'NO_TARIFF_MIGRATION',

  /*
   * Redirect for:
   */
  CHECK_STOCK_ERROR = 'CHECK_STOCK_ERROR',
  CHECK_RETENTION_ERROR = 'CHECK_RETENTION_ERROR',
  CHECK_PREPAID2POSTPAID_ERROR = 'CHECK_PREPAID2POSTPAID_ERROR',


  /*
   * Custom, used only on front:
   */
  UNFINISHED_SLOTS = 'UNFINISHED_SLOTS',
}
